import { action, Action } from 'easy-peasy';
import { isEqual } from 'lodash';
import { ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import { IThresholdIdMap } from '@/types';

export interface ISvipWatermarkModel {
    destroy: Action<ISvipWatermarkModel>;
    /** 是否展示水印 */
    isRenderWatermark: boolean;
    setIsRenderWatermark: Action<ISvipWatermarkModel, boolean>;

    /** 是否会员模板 */
    isVipTemplate: boolean;
    setIsVipTemplate: Action<ISvipWatermarkModel, boolean>;

    /** 会员素材对应的图层 */
    thresholdToLayersMap: Map<string, string[]>;
    setThresholdToLayersMap: Action<ISvipWatermarkModel, Map<string, string[]>>;

    /** 应用中的会员素材信息列表 */
    materialList: IThresholdIdMap[];
    setMaterialList: Action<ISvipWatermarkModel, IThresholdIdMap[]>;

    /** 接口素材信息缓存 */
    thresholdIdMap: Map<string, IThresholdIdMap>;
    setThresholdIdMap: Action<ISvipWatermarkModel, Map<string, IThresholdIdMap>>;

    /** 舞台上用到素材 */
    stageMaterialIdMap: Map<number, string[]>;
    setStageMaterialIdMap: Action<ISvipWatermarkModel, Map<number, string[]>>;

    /** 舞台上用到素材对应的标签id（分类id） */
    stageMaterialLabelMap: Map<number, number | string>;
    setStageMaterialLabelMap: Action<ISvipWatermarkModel, { materialId: number; labelId: number | string }>;

    /** 最终渲染的水印图层数据 */
    finalWatermarkData: Map<number, { watermarkLayers: ILayerProps[]; isGlobal: boolean }>;
    setFinalWatermarkData: Action<
        ISvipWatermarkModel,
        Map<number, { watermarkLayers: ILayerProps[]; isGlobal: boolean }>
    >;
}
export const svipWatermarkModel: ISvipWatermarkModel = {
    destroy: action((state) => {
        state.finalWatermarkData.clear();
        state.stageMaterialLabelMap.clear();
        state.isRenderWatermark = false;
        state.isVipTemplate = false;
        state.materialList = [];
        state.stageMaterialIdMap.clear();
        state.thresholdIdMap.clear();
        state.thresholdToLayersMap.clear();
    }),
    isRenderWatermark: false,
    setIsRenderWatermark: action((state, payload) => {
        if (payload !== state.isRenderWatermark) state.isRenderWatermark = payload;
    }),

    isVipTemplate: false,
    setIsVipTemplate: action((state, payload) => {
        state.isVipTemplate = payload;
    }),

    thresholdToLayersMap: new Map(),
    setThresholdToLayersMap: action((state, payload) => {
        state.thresholdToLayersMap = payload;
    }),

    materialList: [],
    setMaterialList: action((state, payload) => {
        if (!isEqual(state.materialList, payload)) {
            state.materialList = payload;
        }
    }),

    thresholdIdMap: new Map(),
    setThresholdIdMap: action((state, payload) => {
        state.thresholdIdMap = payload;
    }),

    stageMaterialLabelMap: new Map(),
    setStageMaterialLabelMap: action((state, payload) => {
        state.stageMaterialLabelMap.set(payload.materialId, payload.labelId);
    }),
    stageMaterialIdMap: new Map(),
    setStageMaterialIdMap: action((state, payload) => {
        state.stageMaterialIdMap = payload;
    }),

    finalWatermarkData: new Map(),
    setFinalWatermarkData: action((state, payload) => {
        state.finalWatermarkData.clear();
        payload.forEach((val, index) => {
            state.finalWatermarkData.set(index, val);
        });
    }),
};
